import React, { Component } from "react";

import { RETURNS } from "npmlinks-constants";

const { RETURN_COMPLETE, EXCHANGE_COMPLETE } = RETURNS;

class ExchangeComplete extends Component {
  // eslint-disable-next-line class-methods-use-this
  get msgBlock() {
    return (
      <div className="nw-exchangecomplete-msg">
        <p>{EXCHANGE_COMPLETE.MESSAGE1}</p>
        <p className="nw-exchangecomplete-msgdata">
          {EXCHANGE_COMPLETE.MESSAGE2}
        </p>
      </div>
    );
  }

  render() {
    return (
      <div className="nw-exchangecomplete-block">
        <img
          src={RETURN_COMPLETE.COMPLETE_IMAGE}
          alt={RETURN_COMPLETE.COMPLETE_IMAGE}
          className="nw-exchangecomplete-image"
        />
        <h3 className="nw-exchangecomplete-title">{EXCHANGE_COMPLETE.TITLE}</h3>
        {this.msgBlock}
      </div>
    );
  }
}

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ExchangeComplete,
  component: ExchangeComplete,
};

export default ProjectComponent;
